import React from 'react';
import logo from '../images/crms/salesforce.svg';

function Salesforce(props) {
    const className = props.className;
    return (
        <img
            src={logo}
            alt=""
            className={className}
            style={{ width: '130%', height: '130%', objectFit: 'contain' }}
        />
    );
}

export default Salesforce;
